import debug from 'debug'

/*
 * To show CXF-WEBSHOP debug messages just run in a browser console
 * localStorage.debug = 'CXF-WEBSHOP:*'
 */
const logger = debug('CXF-WEBSHOP')
export const log = (argument0: any, ...rest: any[]): void => logger(argument0, ...rest)

export const logError = (...arguments_: any[]): void =>
    // tslint:disable-next-line:no-console
    console.error('%c CXF-WEBSHOP ->', 'background: #ff0000; color: #fff', ...arguments_)
